import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {GridApi, GridOptions} from 'ag-grid-community';
import {StepComponent, StepData} from '../../../stepper/step/step.component';
import {StepperService} from '../../../stepper/stepper.service';
import {Step} from '../../../stepper/step/step';
import {ExecutionService} from '../../../stepper/execution/execution.service';
import {untilDestroyed} from 'ngx-take-until-destroy';
import {ExecutionStateEnum} from '../../../stepper/execution/execution-state.enum';
import {ExcelUtil} from '../../util/excel.util';

@Component({
    selector: 'mydocma-export-step-data-result',
    templateUrl: './export-step-data-result.component.html',
    styleUrls: ['./export-step-data-result.component.scss']
})
export class ExportStepDataResultComponent implements StepComponent, OnInit, OnDestroy {

    @Output()
    public exportEvent = new EventEmitter();

    @Input()
    public step: Step;

    public isExecutionVisible = false;

    private gridApi: GridApi = null;

    public gridOptions: GridOptions = {
        columnDefs: [],
        rowData: [],
        rowSelection: 'single',
        singleClickEdit: true,
        suppressCellSelection: true,
        suppressDragLeaveHidesColumns: true,
        defaultColDef: {
            suppressSizeToFit: true,
            resizable: true,
        },
        context: {componentParent: this},
        onGridReady: (param) => {
            this.gridApi = param.api;
        }
    };

    constructor(
        private readonly stepperService: StepperService,
        private readonly executionService: ExecutionService
    ) {
    }

    public ngOnInit() {
        this.executionService.state$
            .pipe(untilDestroyed(this))
            .subscribe(state => {
                this.isExecutionVisible = state !== ExecutionStateEnum.NotStarted;
            });
    }

    public enter() {
        const tableData = [...this.step.data.exportData];
        tableData.unshift([...this.step.data.exportDataHeaders]);

        this.renderTableGrid(tableData);

        this.stepperService.setStepData(this.step, {
            error: null,
            data: this.step.data,
            valid: true
        });
    }

    public async validate(): Promise<StepData> {
        return {
            error: null,
            data: this.step.data,
            valid: true
        };
    }

    public export() {
        ExcelUtil.generateExcel(this.step.data.exportDataHeaders, this.step.data.exportData, 'export');

        this.exportEvent.emit();
    }

    public async previousStep() {
        await this.stepperService.prevStep();
    }

    public ngOnDestroy() {
    }

    private renderTableGrid(tableData: any[][]) {
        this.gridOptions.columnDefs = [];
        this.gridOptions.rowData = [];

        tableData.forEach(((rowArray, rowIndex) => {
            if (rowIndex === 0) {
                let fieldName = 0;
                rowArray.forEach((headerName) => {
                    this.gridOptions.columnDefs.push({
                        headerName,
                        field: (fieldName++).toString()
                    });
                });

                return;
            }

            this.gridOptions.rowData.push(Object.assign({}, rowArray));
        }));
    }
}
